import React from "react"

const Toolbar = ({children, activeToolbar, theme}) => {
    return (
        <div className={`${theme.toolbarClassName} toolbar ${activeToolbar ? "toolbar-active" : ""}`}>
            {children}
        </div>
    )
}

export default Toolbar
